<template>
    <pm-app-component hide-sidebar barColor="#8dc243">
        <template>
            <template slot="mobile-toolbar">
                <pm-application-bar>
                    {{ $t('photos.title') }}
                </pm-application-bar>
                <!--mdi class="white--text" @click="toggleGrid" :key="grid">
                    <template v-if="grid===4">checkerboard</template>
                    <template v-else-if="grid===3">grid</template>
                    <template v-else-if="grid===2">grid-large</template>
                    <template v-else>view-agenda-outline</template>
                </mdi-->
            </template>

            <div id="main-container" class="app-content-container" style="padding: 0!important; box-shadow: inset 0 8px 15px rgba(0,0,0,.03);">
                <div style="position: absolute; top: 0px; bottom: 0px; left: 0; right: 0; padding: 0; display: flex; flex-direction: column;">
                    <div class="pm-gallery-breadcrumbs">
                        <mdi size="18" style="margin: 0 5px 0px 0;">heart-outline</mdi> {{ $t('photos.favourites') }}
                    </div>
                    <div v-if="items.length ===0" style="display: flex; justify-content: center; align-items: center; height: Calc(100vh - 180px);">
                        {{ $t('photos.no_favourites_added') }}
                    </div>
                    <div :class="['pm-gallery-grid-'+grid]" style="padding-top: 12px; padding-bottom: 20px; flex-grow: 1; flex-shrink: 1; overflow-y: auto; -webkit-overflow-scrolling: touch; scroll-behavior: smooth;">
                        <div class="pm-gallery-media-grid" id="gallery_list_favourites">
                            <pm-media-item v-for="(item, idx) in items" @click="openViewer(idx)" :key="item.id" :item=item  />
                        </div>
                    </div>
                </div>
            </div>
        </template>
        <pm-photo-swipe ref="photoSwipe" @toggleFavved="reload" />
    </pm-app-component>
</template>


<script>
import toolbarMixin from "../../extensions/mixins/mixin-toolbar";
import ErrorBoundary from "@/components/core/error-boundary";
import MediaList from "../../configs/gallery/media";
import PmMediaItem from "./media-item";
import PmPhotoSwipe from "./photoswipe";

const defaultGrid = 2;

export default {
    name: "PmModGalleryFavourites",
    mixins: [toolbarMixin],
    components: {
        ErrorBoundary,
        PmMediaItem,
        PmPhotoSwipe,
    },
    data: () => ({
        grid: defaultGrid,
        items: [],
    }),
    created() {
        // if (localStorage.getItem('galleryGrid')) this.grid = parseInt(localStorage.getItem('galleryGrid'));
        this.items = this.getFavvedItems();
    },
    activated() {
        this.items = this.getFavvedItems();
    },
    mounted() {
        if (window["packageName"] === "com.denticalc.photos") {
            window.app.notifyFlutterMounted();
        }
    },
    methods: {
        openViewer(idx) {
            this.$refs['photoSwipe'].init({
                start: idx,
                items: this.items,
                galleryId: 0,
                galleryTitle: "Favourites",
                categoryTitle: "Favourites"
            });
        },
        reload() {
            this.items = this.getFavvedItems();
        },
        getFavvedItems() {
            const stored = localStorage.getItem('favvedGalleryMedia');
            if (stored === null) return [];
            const favved = JSON.parse(stored);
            const favvedItems = MediaList.filter((item) => {
                return favved.includes(item.id);
            });
            return favvedItems;
        },
        toggleGrid() {
            this.grid--;
            if (this.grid === 0) this.grid = 4;
            localStorage.setItem('galleryGrid', this.grid);
        },
    },
    toolbar() {
        const items = [];

        items.push({
            mdi: "image-outline",
            text: "Photos",
            callback: () => {
                this.$router.push('/gallery');
            },
        });

         items.push({
            mdi: "emoticon-happy-outline",
            text: "Before-after",
            callback: () => {
                this.$router.push('/gallery-before-after').catch(_ => {});
            },
        });

        items.push({
            mdi: "heart-outline",
            text: "Favourites",
            active: true,
            callback: () => {
                this.$router.push('/gallery-favourites');
            },
        });

        items.push({
            back: true,
            callback: () => {
                if (window.prevGalleryId > 0) this.$router.push('/gallery/'+window.prevGalleryId);
                else this.$router.push('/gallery');
            },
        });

        return ([items]);
    },
};

</script>

<style>
@media (min-width: 700px) {
    .favourites--empty {
        font-size: 16px !important;
    }
}
</style>
